import { action, createRequestTypes } from '../base';

export const addToCartActionTypes = {
  NEW_ADD_TO_CART: createRequestTypes('NEW_ADD_TO_CART'),
  NEW_REMOVE_FROM_CART: createRequestTypes('NEW_REMOVE_FROM_CART'),
  NEW_GET_CART: createRequestTypes('NEW_GET_CART'),
};

class AddToCartActions {
  addToCartV2 = (payload, callback) => {
    return action(addToCartActionTypes.NEW_ADD_TO_CART.REQUEST, {
      payload, callback,
    });
  };

  addToCartLoadingV2 = (addToCartLoadingV2) => action(addToCartActionTypes.NEW_ADD_TO_CART.LOADING, {
    addToCartLoadingV2,
  });

  removeFromCartV2 = (payload, callback) => action(addToCartActionTypes.NEW_REMOVE_FROM_CART.REQUEST, {
    payload, callback,
  });

  removeFromCartV2Loading = (removeFromCartV2Loading) => action(addToCartActionTypes.NEW_REMOVE_FROM_CART.LOADING, {
    removeFromCartV2Loading,
  });

  getCartV2 = (payload, callback) => action(addToCartActionTypes.NEW_GET_CART.REQUEST, {
    payload, callback,
  });

  getCartV2Loading = (getCartV2Loading) => action(addToCartActionTypes.NEW_GET_CART.LOADING, {
    getCartV2Loading,
  });

  getCartV2Success = (cartDataV2) => action(addToCartActionTypes.NEW_GET_CART.SUCCESS, {
    cartDataV2,
  });
}

export default new AddToCartActions();
